import React, {Fragment} from 'react'
import {getTime, outputMoney} from '@/public/utils'
import {Popover, Typography} from 'antd'
import {QuestionCircleOutlined} from '@ant-design/icons'
import {Link} from 'react-router-dom'
const { Paragraph } = Typography

export const payStatusOptions = [{
  label: '已支付',
  value: '已支付'
}, {
  label: '待支付',
  value: '待支付'
}, {
  label: '部分支付',
  value: '部分支付'
}]

const payStatusColorMap = {
  已支付: '#00a854',
  待支付: '#ffbf00',
  部分支付: '#0e77d1'
}
const paymentPayStatusColorMap = {
  success: '#00a854',
  part_fail: 'red',
  fail: 'red',
  cancel: '#dddfe2',
  bank_refund: '#0e77d1'
}
export const getColumns = ({showDetail, showMatchInfo}) => {
  return [
    {
      title: '视客账单号',
      key: 'supplier_account_code',
      dataIndex: 'supplier_account_code',
      width: 120,
      fixed: 'left',
      align: 'center',
      render (text, record) {
        return <Link to={`/main/supplierRecantion/listDetails?code=${text}&poSubjectName=${record.po_subject_name}`}
          style={{color: '#189eff'}} target={'_blank'}>{text}</Link>
      }
    },
    {
      title: '账单期间',
      key: 'supplier_account_begin_date',
      align: 'center',
      width: 180,
      dataIndex: 'supplier_account_begin_date',
      render (text, record) {
        return <Fragment>
          {getTime(text, 'YYYY-MM-DD')}
          <span style={{padding: '0 4px'}}>~</span>
          {getTime(record.supplier_account_end_date, 'YYYY-MM-DD')}
        </Fragment>
      }
    },
    {
      title: <div style={{textAlign: 'center'}}>账单金额</div>,
      key: 'statement_amount',
      align: 'right',
      dataIndex: 'statement_amount',
      width: 120,
      render: (text) => outputMoney(text)
    },
    {
      title: '账单确认时间',
      align: 'center',
      width: 100,
      key: 'supplier_account_date',
      dataIndex: 'supplier_account_date',
      render: (text) => getTime(text, 'YYYY-MM-DD')
    },
    {
      title: <div style={{textAlign: 'center'}}>预计付款时间</div>,
      align: 'left',
      width: 100,
      key: 'payable_date_list',
      dataIndex: 'payable_date_list',
      render: (text) => (
        <Popover
          content={
            (text || []).map(el => <div>{getTime(el, 'YYYY-MM-DD')}</div>)
          }>
          {getTime((text || [])[0], 'YYYY-MM-DD')}{text.length > 1 && '...'}
        </Popover>
      )
    },
    {
      title: <div style={{textAlign: 'center'}}>已支付金额</div>,
      align: 'right',
      key: 'paidamount',
      dataIndex: 'paidamount',
      width: 150,
      render: (text, record) => text
        ? (
          <span>
            {outputMoney(text)}
            <a
              style={{color: 'orange', marginLeft: 6}}
              hidden={(record.settlement_code_list || []).filter(el => el).length !== 1}
              onClick={() => showDetail(record)}
            >
              详情
            </a>
          </span>
        ) : '--'
    },
    {
      title: <div style={{textAlign: 'center'}}>未支付金额</div>,
      align: 'right',
      key: 'residue_amount',
      dataIndex: 'residue_amount',
      width: 120,
      render: (text) => <span style={{color: text > 0 ? 'red' : ''}}>{outputMoney(text)}</span>
    },
    {
      title: '支付状态',
      align: 'center',
      width: 90,
      key: 'payment_status_str',
      dataIndex: 'payment_status_str',
      render (text) {
        return <span>
          <span style={{
            display: 'inline-block',
            width: 6,
            height: 6,
            borderRadius: 3,
            marginRight: 4,
            backgroundColor: payStatusColorMap[text]
          }}/>
          {text}
        </span>
      }
    },
    {
      title: <div>
        实际付款时间
        <Tip content={'对账单最近一次付款的时间'}/>
      </div>,
      key: 'pay_time',
      align: 'center',
      dataIndex: 'pay_time',
      width: 120,
      render: (text) => getTime(text, 'YYYY-MM-DD')
    },
    {
      title: <div style={{textAlign: 'center'}}>
        已匹配发票金额
        <Tip content={'对账单已匹配过发票的金额'}/>
      </div>,
      align: 'right',
      key: 'invoice_amount',
      dataIndex: 'invoice_amount',
      width: 140,
      render: (text) => outputMoney(text)
    },
    {
      title: <div style={{textAlign: 'center'}}>
        未匹配发票金额
        <Tip content={'对账单剩余未匹配过发票的金额'}/>
      </div>,
      align: 'right',
      width: 140,
      key: 'invoice_remain_amount',
      dataIndex: 'invoice_remain_amount',
      render: (text) => <span style={{color: text > 0 ? 'red' : ''}}>{outputMoney(text)}</span>
    }
  ]
}

export const expendColumn = ({showDetail, showMatchInfo}) => {
  return [
    {
      title: '预计付款时间',
      align: 'center',
      key: 'payable_date',
      dataIndex: 'payable_date',
      render: (text) => getTime(text, 'YYYY-MM-DD')
    },
    {
      title: <div style={{textAlign: 'center'}}>账单金额</div>,
      align: 'right',
      key: 'statement_amount',
      dataIndex: 'statement_amount',
      render: (text) => outputMoney(text)
    },
    {
      title: <div style={{textAlign: 'center'}}>已支付金额</div>,
      align: 'right',
      key: 'paidamount',
      dataIndex: 'paidamount',
      render: (text, record) => text
        ? (
          <span>
            {outputMoney(text)}
            <a
              style={{color: 'orange', marginLeft: 6}}
              hidden={!record.settlement_code}
              onClick={() => showDetail(record)}
            >
              详情
            </a>
          </span>
        ) : '--'
    },
    {
      title: <div style={{textAlign: 'center'}}>未支付金额</div>,
      align: 'right',
      key: 'residue_amount',
      dataIndex: 'residue_amount',
      render: (text) => outputMoney(text)
    },
    {
      title: '支付状态',
      align: 'center',
      key: 'payment_status_str',
      dataIndex: 'payment_status_str',
      render (text) {
        return <span>
          <span style={{
            display: 'inline-block',
            width: 6,
            height: 6,
            borderRadius: 3,
            marginRight: 4,
            backgroundColor: payStatusColorMap[text]
          }}/>
          {text}
        </span>
      }
    },
    {
      title: '实际付款时间',
      key: 'pay_time',
      align: 'center',
      dataIndex: 'pay_time',
      render: (text) => getTime(text, 'YYYY-MM-DD')
    },
    {
      title: <div style={{textAlign: 'center'}}>
        已匹配发票金额
      </div>,
      align: 'right',
      key: 'invoice_amount',
      dataIndex: 'invoice_amount',
      render: (text) => outputMoney(text)
    },
    {
      title: <div style={{textAlign: 'center'}}>
        未匹配发票金额
      </div>,
      align: 'right',
      key: 'invoice_remain_amount',
      dataIndex: 'invoice_remain_amount',
      render: (text) => outputMoney(text)
    }
  ]
}

export const paymentDetailColumn = [
  {
    title: '付款时间',
    align: 'center',
    key: 'payment_time',
    dataIndex: 'payment_time',
    width: 160,
    render: (text) => getTime(text)
  },
  {
    title: <div style={{textAlign: 'center'}}>实际付款金额</div>,
    align: 'right',
    key: 'real_pay_amount',
    dataIndex: 'real_pay_amount',
    width: 100,
    render: (text) => outputMoney(text)
  },
  {
    title: '付款状态',
    align: 'center',
    width: 100,
    key: 'payment_status_desc',
    dataIndex: 'payment_status_desc',
    render (text, record) {
      return <span>
        <span style={{
          display: 'inline-block',
          width: 6,
          height: 6,
          borderRadius: 3,
          marginRight: 4,
          backgroundColor: paymentPayStatusColorMap[record.payment_status]
        }}/>
        {text}
      </span>
    }
  },
  {
    title: '失败原因',
    key: 'failure_reason',
    align: 'center',
    dataIndex: 'failure_reason',
    width: 240,
    render (text) {
      if (!text) return '--'
      return <Popover content={<div style={{width: 500}}>{text}</div>} trigger="hover">
        <div className={'ellipsis'} style={{WebkitBoxOrient: 'vertical', WebkitLineClamp: 2}}>
          {text}
        </div>
      </Popover>
    }
  },
  {
    title: '付款账户',
    key: 'payment_account_name',
    align: 'center',
    dataIndex: 'payment_account_name',
    // width: 120,
    render: (text, record) => {
      return <Fragment>
        <span style={{marginRight: 8}}>{text}</span>{record.payment_account_number}
      </Fragment>
    }
  }
]

function Tip (props) {
  const {children, ...rest} = props
  return <Popover {...rest}>
    <QuestionCircleOutlined style={{marginLeft: 4}}/>
  </Popover>
}

export const purchaseAdvanceColumns = [{
  title: '付款时间',
  align: 'center',
  key: 'payment_time',
  dataIndex: 'payment_time',
  render: (text) => getTime(text)
},
{
  title: '预付款金额',
  align: 'center',
  key: 'real_pay_amount',
  dataIndex: 'real_pay_amount',
  render: (text) => outputMoney(text)
}
]



// WEBPACK FOOTER //
// ./src/pages/statementPaymentProgress/config.js